import * as React from "react";

interface ArrowProps {
  direction: "left" | "right";
}

const assetPrefix = process.env.ASSET_PREFIX || "";

export default function Arrow(props: ArrowProps) {
  return (
    <img
      {...props}
      src={`${assetPrefix}/static/arrow-pointing-${props.direction}.svg`}
    />
  );
}
